/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_By_TimeslotInputs */



/**
* | output |
* | --- |
* | "Enabled by time slot" |
*
* @param {Activate_By_TimeslotInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const activate_by_timeslot = /** @type {((inputs?: Activate_By_TimeslotInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_By_TimeslotInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enabled by time slot")
	return /** @type {LocalizedString} */ ("Activé par plage horaire")
});